<div class="dialog-parent">
  <div class="close-icon">
    <mat-icon (click)="closeDialog()">close</mat-icon>
  </div>

  <mat-toolbar class="test-class">
    <mat-toolbar-row>
      <a [href]="relihUrl" target="_blank"><img class="logo-image" src="/assets/logo/logo-en-transparent.png" /></a>
      <a [href]="habitatUrl" target="_blank"><img class="logo-image" src="/assets/logo/logo-en-transparent1.png"></a>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="dialog-header">
    <h1 *ngIf="currentLanguage == 'mk'" mat-dialog-title> Регистар на станбени згради и станови</h1>
    <h1 *ngIf="currentLanguage == 'en'" mat-dialog-title> REGISTER OF APARTMENT BUILDINGS AND APARTMENTS</h1>
  </div>



  <div mat-dialog-content *ngIf="currentLanguage == 'mk'">
    <p>
      Електронскиот регистар на станбени згради во моментот содржи податоци, изработени во перидот од 2015 до август
      2022 година, за 35 општини од РС Македонија, 4744 станбени згради и 128005 станови. Покрај податоците пропишани во
      Законот за домување и Правилникот за формата, содржината и начинот на водење на регистарот на станбени згради и
      станови, и на регистарот на управители на станбени згради, електронскиот регистар содржи и податоци за основните
      градежни и енергетски карактеристики на зградите.
    </p>

    <p>
      Електронскиот регистар овозможува пребарување, анализа и ажурирање на карактеристиките на станбениот фонд со цел
      да овозможи унапредување на квалитетот на домување во станбените згради и подобрување на енергетската ефикасност.
    </p>

    <p>
      Преку оваа апликација имате пристап и може да ги добиете следните податоци:
    </p>

    <ul>
      <li>
        Општи податоци (адреса, година на градба, број на станови, година на реновирање, начин на управување на
        станбената зграда итн.),
      </li>
      <li>
        Географски локации на станбените згради на Google maps,
      </li>
      <li>
        Состојба, односно одржаност и оштетувања на фасадата, покривот, прозорците,
      </li>
      <li>
        Податоци за користениот градежен материјал,
      </li>
      <li>
        Начинот на управување на станбените згради,
      </li>
      <li>
        Енергетските барања за греење во постојната состојба,
      </li>
      <li>
        Процена на потенцијалните енергетски заштеди при примената на мерки за енергетска ефикасност,
      </li>
      <li>
        Пресметка на финансиската исплатливост на секоја поединечна мерка, како и пакет од сите мерки,
      </li>
      <li>
        Потенцијалните намалувања на емисии на штетни гасови во атмосферата при примената на мерки за енергетска
        ефикасност, односно намалување на влијанието врз околината и климатските промени.
      </li>
    </ul>

    <p>
      Во прегледот дадени се податоци за завршените регистри на станбени згради во 35 општини (изработени во периодот од
      2015 до 2022 година) и податоци за енергетските карактеристики за станбените згради од 16 општини. Хабитат
      Македонија продолжува со реализацијата на оваа активност во останатите општини.
    </p>

    <p>
      Електронскиот регистар на станбени згради е наменет за станарите, заедниците на сопственици на станови,
      управителите на станбени згради, локалната самоуправа, и сите други засегнати страни и треба да придонесе кон
      подобро планирање и реализација на активности за управување со станбени згради и енергетска ефикасност во
      станбениот сектор.
    </p>

  </div>

  <div mat-dialog-content *ngIf="currentLanguage == 'en'">
    <p>
      The electronic register of apartment buildings currently contains data, made in the period from 2015 to august
      2022, on 35 municipalities in the Republic of North Macedonia, 4,744 buildings and 128005 apartments. In addition
      to the data prescribed in the Law on Housing and the Rulebook on the form, content and way of keeping the register
      of apartment buildings and apartments, and the register of apartment buildings management companies, the
      electronic register also contains data on the basic construction and energy characteristics of the buildings.
    </p>
    <p>
      The electronic register allows search, analysis and update of the characteristics of the housing stock in order to
      enable the improvement of the quality of housing in apartment buildings and the improvement of energy efficiency.
    </p>
    <p>
      Through this application you have access to and can receive the following data:
    </p>

    <ul>
      <li>
        General data (address, year of construction, number of apartments, year of renovation, way of managing the
        apartment building, etc.),
      </li>
      <li>
        Geographical location of residential buildings on Google maps,
      </li>
      <li>
        Condition, i.e. maintenance and damage of the facade, roof, windows,
      </li>
      <li>
        Data on the used construction materials,
      </li>
      <li>
        The type of building management,
      </li>
      <li>
        Heating energy demand in the existing state,
      </li>
      <li>
        Assessment of potential energy savings when applying energy efficiency measures,
      </li>
      <li>
        Calculation of the financial profitability of each individual measure, as well as a package of all measures,
      </li>
      <li>
        Potential reductions in emissions of harmful gasses in the atmosphere after the application of energy efficiency
        measures, that is, reduction of the impact on the environment and climate change.
      </li>
    </ul>

    <p>
      You can review data from the completed registers of apartment buildings in 35 municipalities (made in the period
      from 2015 to 2022) and data on the energy characteristics of residential buildings from 16 municipalities. Habitat
      Macedonia continues with the implementation of this activity in other municipalities.
    </p>
    <p>
      The electronic register of residential buildings is intended for use by homeowners, homeowner’s associations,
      apartment buildings management companies, local self-government, and all other stakeholders and should contribute
      to better planning and implementation of activities for managing residential buildings and energy efficiency in
      the residential sector.
    </p>
  </div>

</div>
